import React, { useState, useContext, useEffect } from "react";
import classNames from "classnames/bind";
import ListLocation from "./ListLocation";
import useFetchLocation from "../../Location/useFetchLocation";
import Header from "../../Location/Header";
import { MapContext } from "../../../contexts";
import styles from "../Map.module.css";
import { DownIcon, LeftIcon } from "../../../components/Icons/Icons";
import Filter from "../../Location/Filter/Filter";
import { Button, Skeleton, Toast } from "../../../components";
import SearchFail from "../../Location/SearchFaild/SearchFail";
import { sorterArray } from "../../../utils";
import { actions } from "../../../store";
import { useStoreContext } from "../../../hooks/useStoreContext";
const cx = classNames.bind(styles);
const SideBarMap = () => {
  const [dataStore, dispatch] = useStoreContext();
  const { isApply, setIsApply, isGroup, setIsGroup, setGroup } =
    useContext(MapContext);
  // const {
  //     isLoadingCamera,
  //     setCurrentPage,
  //     screen,
  //     setScreen,
  //     isFullScreen,
  //     setIsFullScreen,
  //     showTaskbar,
  //     setShowTaskBar,
  //     oneThread, setOnThread,
  //     isGroup,
  //     setGroupCode
  //   } = React.useContext(CameraContext);
  const [filter, setFilter] = useState([]);
  const [value, setValue] = useState();
  const [listLocation, setListLocation] = useState([]);
  const [isFilter, setIsFilter] = useState(false);
  //eslint-disable-next-line
  const [isSearchFail, setIsSearchFail] = useState(false);
  const [groupCam, setGroupCam] = useState();
  const [provinceCode, setProvinceCode] = useState();

  const handleShowWarehouse = (value) => {
    const data = listLocation.map((item, index) => {
      if (index === value) {
        return {
          ...item,
          isShow: !item.isShow,
          icon: !item.isShow ? <DownIcon /> : <LeftIcon />,
        };
      }
      return {
        ...item,
        isShow: false,
        icon: <LeftIcon />,
      };
    });
    setListLocation(data);
  };
  const updateValue = (data) => {
    setValue(data);
  };
  const changeFilter = (data) => {
    setFilter(data);
  };
  const updateIsGroup = (data) => {
    setIsGroup(data);
  };
  const handleFilter = (data) => {
    setIsFilter(!isFilter);
    setFilter(data);
  };
  const handleApply = (e) => {
    setIsApply(!isApply);
  };
  const groups = useFetchLocation(
    "warehouse/get-list-group-warehouse-by-username/",
    "warehouse/get-list-province-warehouse-by-username/",
    isGroup,
    { value, provinceCode, groupCam },
    isApply
  );
  console.log(groups);
  
  useEffect(() => {
    if (filter) {
      filter.forEach((item) => {
        switch (item.type) {
          case "group":
            setGroupCam(item.name);
            break;
          case "province":
            setProvinceCode(item.code);
            break;
          default:
            return 0;
        }
      });
    }
  }, [filter]);

  React.useEffect(() => {
    let value;
    if (groups.status === 403) {
      Toast.open("Bạn không có quuyển xem danh sách kho", "danger");
    }
    if (isGroup) {
      value = groups.data?.map((item) => {
        return {
          code: item.GROUP_CODE,
          name: item.GROUP_NAME,
          wareHouses: item.LIST_WAREHOUSE,
          icon: <LeftIcon />,
          isShow: false,
        };
      });
      if (value?.length > 0) {
        setIsSearchFail(false);
      } else {
        setIsSearchFail(true);
      }
    } else {
      value = groups.data?.map((item) => {
        return {
          code: item.PROVINCE_CODE,
          name: item.PROVINCE_NAME,
          wareHouses: item.LIST_WAREHOUSE,
          icon: <LeftIcon />,
          isShow: false,
        };
      });
      if (value && value?.length > 0) {
        setIsSearchFail(false);
      } else {
        setIsSearchFail(true);
      }
    }
    if (value && value?.length > 0 && value[0].code) {
      const data = value?.sort((a, b) =>
        a?.name
          ?.normalize("NFC")
          .localeCompare(b?.name?.normalize("NFC"), "vi", {
            sensitivity: "accent",
          })
      );
      const data2 = data.map((item, index) => {
        return {
          ...item,
          isShow: index === 0 ? true : false,
          icon: index === 0 ? <DownIcon /> : <LeftIcon />,
        };
      });
      let wareShow = []
      data2.forEach((item)=>{
        wareShow = [...wareShow,...item.wareHouses]
      })
      setGroup(data2[0].code);
      dispatch(actions.getListWareHouse(wareShow));
      dispatch(actions.getViewPort(null));
      setListLocation(data2);
    }
  }, [groups.data, groups.status, isGroup]);
  // console.log();

  return (
    <div className={cx("list")}>
      <div id="__notification"></div>
      {isFilter ? (
        <Filter onFilter={handleFilter} isGroup={isGroup} />
      ) : (
        <>
          <Header
            value={value}
            setValue={updateValue}
            filter={filter}
            setFilter={changeFilter}
            handleFilter={handleFilter}
            isGroup={isGroup}
            setIsGroup={updateIsGroup}
            textSearch={false}
            type={"Map"}
          />
          {groups.isLoading ? (
            <div className={cx("loading")}>
              <Skeleton height={48} width={"100%"} />
              <Skeleton height={48} width={"100%"} />
            </div>
          ) : (
            <div className={cx("list-location")}>
              {listLocation && listLocation?.length > 0 && !isSearchFail ? (
                listLocation.map((item, index) => {
                  if (item.wareHouses?.length >= 0) {
                    return (
                      <ListLocation
                        key={index}
                        indexLocation={index}
                        show={item.isShow}
                        onClick={handleShowWarehouse}
                        name={item.name}
                        wareHouses={item.wareHouses}
                        icon={item.icon}
                        code={item.code}
                        value={value}
                        isGroup={isGroup}
                        filter={filter}
                      />
                    );
                  }
                  return <React.Fragment key={index}></React.Fragment>;
                })
              ) : (
                <SearchFail />
              )}
            </div>
          )}
          {isApply && (
            <div className={cx("apply")}>
              <Button
                title="Áp dụng"
                className={cx("btn")}
                onClick={handleApply}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SideBarMap;
